import React from "react";
import {
  Container,
  Stack,
  IconButton,
  Button,
  useMediaQuery,
  Grid,
  Box,
  Divider,
} from "@mui/material";

import buy from "./assets/buy.svg";

function BuyCON() {
  const mobile = useMediaQuery("(max-width:1050px)");

  return (
    <>
      <Box
        className="border"
        width="100%"
        px={mobile ? "28px" : "70px"}
        py={mobile ? "20px" : "48px"}
        sx={{
          background: " rgba(248, 248, 248, 0.1)",
          backdropFilter: "blur(10px)",
          borderRadius: "20px",
          zIndex: "100",
          fontFamily: "regular",
        }}
      >
        <Box width="100%">
          <Box
            width="100%"
            sx={{
              fontSize: mobile ? "16px" : "20px",
              fontWeight: "400",
              color: "white",
              textAlign: "center",
            }}
          >
            Price
          </Box>
          <Box
            py="5px"
            width="100%"
            sx={{
              background: "#454545",
              mixBlendMode: "hue",
              borderRadius: "10px",
              color: "white",
              fontSize: mobile ? "16px" : "20px",
              textAlign: "center",
              boxShadow: "10",
            }}
          >
            $1.22
          </Box>
        </Box>
        <Box mt={"30px"} width="100%">
          <Box
            width="100%"
            sx={{
              fontSize: mobile ? "16px" : "20px",
              fontWeight: "400",
              color: "white",
              textAlign: "center",
            }}
          >
            Market Cap
          </Box>
          <Box
            py="5px"
            width="100%"
            sx={{
              background: "#454545",
              mixBlendMode: "hue",
              borderRadius: "10px",
              color: "white",
              fontSize: mobile ? "16px" : "20px",
              textAlign: "center",
              boxShadow: "10",
            }}
          >
            $21,245
          </Box>
        </Box>
        <Box mt={"30px"} width="100%">
          <Box
            width="100%"
            sx={{
              fontSize: mobile ? "16px" : "20px",
              fontWeight: "400",
              color: "white",
              textAlign: "center",
            }}
          >
            Treasury Reserves
          </Box>
          <Box
            py="5px"
            width="100%"
            sx={{
              background: "#454545",
              mixBlendMode: "hue",
              borderRadius: "10px",
              color: "white",
              fontSize: mobile ? "16px" : "20px",
              textAlign: "center",
              boxShadow: "10",
            }}
          >
            $940
          </Box>
        </Box>
        <Box mt={"30px"} width="100%">
          <Box
            width="100%"
            sx={{
              fontSize: mobile ? "16px" : "20px",
              fontWeight: "400",
              color: "white",
              textAlign: "center",
            }}
          >
            Liquidity Backing
          </Box>
          <Box
            py="5px"
            width="100%"
            sx={{
              background: "#454545",
              mixBlendMode: "hue",
              borderRadius: "10px",
              color: "white",
              fontSize: mobile ? "16px" : "20px",
              textAlign: "center",
              boxShadow: "10",
            }}
          >
            $10000
          </Box>
        </Box>
        <Button
          sx={{
            fontSize: mobile ? "15px" : "25px",
            width: "100%",
            background: "#FAA631",
            "&:hover": {
              background: "white",
              color: "#FAA631",
            },
            color: "white",
            borderRadius: "10px",
            height: "43px",
            marginTop: mobile ? "30px" : "30px",
            fontFamily: "light",
          }}
        >
          BUY CON
        </Button>
      </Box>
      <Box
        my={mobile ? "50px" : "80px"}
        width="100%"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <img
          src={buy}
          style={{
            maxWidth: "542px",
            width: "100%",
          }}
          alt=""
        />
      </Box>
    </>
  );
}

export default BuyCON;
